import { defineStore } from 'pinia'
import actions from './actions.js';
import mutations from './mutations.js';
import getters from './getters.js';


export const compareStore = defineStore('compare', {
    state: () => {
        return {
            singles: [],
            pairs: [],
        }
    },
    getters: { ...getters},
    actions: {...actions, commitMutation: function( mutationToCall, data ) {

        // console.log('mutationToCall, data ', mutationToCall, data )
        try {
            mutations[mutationToCall]( this, data )
        } catch (error) {
            console.error( 'LOOSE COMPARE MUTATION ERROR - ', this, mutationToCall, data, error )
            throw error
        }
    }},
    // persist: true,
})
